import "../assets/css/package.css"
import scanner from "../Photos/Payment/Scanner.png"
import { Button, Input } from "@mui/material";
import "../components/WelcomeSection.css"
import { useEffect, useRef, useState } from "react";
import { paymentRequest, paymentRequestAction } from "../handler/accountHandler";
import growniverseImage from "../Photos/Logo/growniverse-appicon-transparent.svg";
import { MoonLoader } from 'react-spinners';
import { Table, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
interface InnerBannerProps {
    packageId:number,
    packageName:string,
    price:number,
    IsUpgrade: boolean;
    CouponCode: boolean;
    AddNewSponsorGrowniverseId: string;
}
const Payment: React.FC<InnerBannerProps> = ({ packageId,packageName,price, IsUpgrade, CouponCode, AddNewSponsorGrowniverseId }) => {
    const [file, setFile] = useState(null);
    const [transactionId, setTransactionId] = useState(null);
    const [loader, setLoader] = useState(false);
    const [unPaidBalance, setUnPaidBalance] = useState(0);
    const handleFileChange = (event: any) => {
        setFile(event.target.files[0]);
    };
    const handleTrChange = (event: any) => {
        setTransactionId(event.target.value);
    };

    const runOnce = useRef(false);
    const calculateGst = (price: number) => {
        return Math.round(Number(price) + price * 0.18)
    }
    const [paymentMethod, setPaymentMethod] = useState("");
    useEffect(() => {
        if (runOnce.current === false) {
            const storedProfile = localStorage.getItem("userProfile");
            const userProfile = JSON.parse(storedProfile ?? "");
            const storedAccount = localStorage.getItem("account");
            const userAccount = JSON.parse(storedAccount ?? "");
            setUnPaidBalance(userAccount.unPaidBalance);
            window.scrollTo(0, 0);
            runOnce.current = true;
        }
    }, [runOnce])
    return <>
        <section
            style={{
                minHeight: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                background: "radial-gradient(circle at center, #0d0d1a, #000000)", // dark galaxy background
                padding: "40px",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* Animated stars */}
            <div className="stars"></div>
            <div className="stars2"></div>
            <div className="stars3"></div>

            <h1 style={{ marginBottom: "30px", color: "#fff", fontWeight: 700 }}>
                💳 Payment Summary
            </h1>

            <div
                style={{
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "25px",
                    width: "100%",
                    maxWidth: "640px",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.4)",
                    borderTop: "4px solid #1E88E5",
                    zIndex: 10,
                }}
            >
                {/* Billing Table */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "12px",
                        borderBottom: "1px solid #eee",
                        paddingBottom: "10px",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#333",
                    }}
                >
                    <span>Package Name</span>
                    <span style={{ fontWeight: "500", color: "#222" }}>
                        {packageName}
                    </span>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "12px",
                        borderBottom: "1px solid #eee",
                        paddingBottom: "10px",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#333",
                    }}
                >
                    <span>Base Price</span>
                    <span style={{ fontWeight: "700", color: "#25da73", fontSize: "18px" }}>
                        ₹{price}
                    </span>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "12px",
                        borderBottom: "1px solid #eee",
                        paddingBottom: "10px",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#333",
                    }}
                >
                    <span>Fees & Charges</span>
                    <span style={{ fontWeight: "700", color: "#25da73", fontSize: "18px" }}>
                        ₹{calculateGst(price) -
                            (price)}
                    </span>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        color: "#2E7D32",
                        fontWeight: "bold",
                        fontSize: "20px",
                        borderTop: "1px solid #ccc",
                        paddingTop: "10px",
                    }}
                >
                    <span>Total Amount</span>
                    <span>
                        ₹{calculateGst(price)}
                    </span>
                </div>

                {/* Payment Button */}
                <button
                    style={{
                        marginTop: "25px",
                        width: "100%",
                        padding: "14px",
                        borderRadius: "8px",
                        background: "#1E88E5",
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: 600,
                        border: "none",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                    }}
                    // onClick={packagePaymentTransaction}
                >
                    Proceed to Payment
                </button>
            </div>

            {/* Universe background animation */}
            <style>
                {`
      .stars, .stars2, .stars3 {
        position: absolute;
        width: 100%;
        height: 100%;
        background: transparent url('https://www.script-tutorials.com/demos/360/images/stars.png') repeat top center;
        animation: moveStars 60s linear infinite;
      }
      .stars2 {
        background-size: 2px 2px;
        animation: moveStars 120s linear infinite;
        opacity: 0.5;
      }
      .stars3 {
        background-size: 3px 3px;
        animation: moveStars 180s linear infinite;
        opacity: 0.3;
      }
      @keyframes moveStars {
        from { transform: translateY(0); }
        to { transform: translateY(-1000px); }
      }
    `}
            </style>
        </section>


    </>
};

export default Payment;